var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBroomSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14.225,
    viewBox: "0 0 16 14.225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "broom-solid",
    d: "M15.74,1.444A.89.89,0,0,0,14.481.185L9.148,5.519l-.964-.964A.629.629,0,0,0,7.111,5v.808L10.12,8.816h.808a.629.629,0,0,0,.444-1.072l-.964-.964,5.334-5.334Zm-6.264,8.3L6.184,6.452A4.059,4.059,0,0,0,2.967,7.627l-.222.222a3.3,3.3,0,0,0-.967,2.333.254.254,0,0,0,.367.228L3.564,9.7a.134.134,0,0,1,.15.219L.2,13.078a.622.622,0,0,0-.2.458.614.614,0,0,0,.614.614H5.428A4.061,4.061,0,0,0,9.475,9.744Z",
    transform: "translate(0 0.075)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroomSolid);
export default __webpack_public_path__ + "static/media/broom-solid.ad1bcd9eef70cb96b6ca5ecbdf4142a5.svg";
export { ForwardRef as ReactComponent };